import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import * as APITypes from "~/API";

export const LeaseOfferStatusTag = ({
  status,
}: {
  status: APITypes.OfferStatusType;
}) => {
  const { t } = useTranslation();
  switch (status) {
    case APITypes.OfferStatusType.Completed: {
      return <Tag color="success">{t("Complete")}</Tag>;
    }
    case APITypes.OfferStatusType.Rejected: {
      return <Tag color="error">{t("Rejected")}</Tag>;
    }
    case APITypes.OfferStatusType.Canceled: {
      return <Tag color="error">{t("Cancelled")}</Tag>;
    }
    case APITypes.OfferStatusType.InProgress: {
      return <Tag color="processing">{t("InProgress")}</Tag>;
    }
    case APITypes.OfferStatusType.Pending: {
      return <Tag color="processing">{t("Pending")}</Tag>;
    }
    case APITypes.OfferStatusType.TenantComplete: {
      return <Tag color="warning">Tenant Complete</Tag>;
    }
    case APITypes.OfferStatusType.LandlordComplete: {
      return <Tag color="warning">Landlord Complete</Tag>;
    }
  }
};
